<div class="row containers">
  <div class="left-container">
    <div class="left-header-div">
      <span class="left-header font-gellix-bold-12-14">{{ leftHeader }}</span>
      <span class="agent-count font-gellix-medium-12-14">{{ count.availableCount }}</span>
    </div>
    <div class="hr-divider"></div>
    <div class="input-div">
      <div class="search-div">
        <input
          class="search"
          [(ngModel)]="search"
          (keyup)="applyFilterByName($event.target)"
          type="text"
          placeholder="Search"
        />
      </div>
      <div class="multi-select-dropdown-div" *ngIf="this.objectType?.toLowerCase() === 'agent'">
        <select
          name="groupdropdown"
          class="groupdropdown drpdown"
          [(ngModel)]="selectedGroup.label"
          (change)="selectByGroup($event.target)"
        >
          <option [value]="item.label" *ngFor="let item of agentGroups">
            {{ item.label }}
          </option>
        </select>
      </div>
    </div>
    <div class="left-list-container">
      <ng-container *ngIf="filteredAvailableDisplay.length > 0 && filteredAvailableDisplay[0].options; else elseblock">
        <select
          class="left-list-select"
          multiple="multiple"
          size="8"
          *ngIf="filteredAvailableDisplay.length > 0"
          [(ngModel)]="selectedAgents"
        >
          <ng-container *ngFor="let item of filteredAvailableDisplay">
            <optgroup [label]="item?.label">
              <ng-container *ngFor="let option of item.options">
                <option
                  [value]="option.value"
                  *ngIf="option.selected == false"
                  [ngValue]="option"
                  [title]="option.tooltip"
                >
                  {{ option.label }}
                </option>
              </ng-container>
            </optgroup>
          </ng-container>
        </select>
      </ng-container>
      <ng-template #elseblock>
        <select
          class="left-list-select"
          multiple="multiple"
          size="8"
          *ngIf="filteredAvailableDisplay.length > 0"
          [(ngModel)]="selectedAgents"
        >
          <ng-container *ngFor="let item of filteredAvailableDisplay">
            <option [value]="item.value" *ngIf="item.selected == false" [ngValue]="item" [title]="item.tooltip">
              {{ item.label }}
            </option>
          </ng-container>
        </select>
      </ng-template>
    </div>
  </div>
  <div class="ctrl-container">
    <div class="ctrls">
      <button
        *ngIf="!disabled"
        type="button"
        class="ctrl-btn main-btn green mb-2"
        aria-label="Left Align"
        (click)="moveRight()"
      >
        <img alt="" src="{{ baseHref }}/assets/images/icon-forward.png" class="ctrl-img" />
      </button>

      <button
        *ngIf="!disabled"
        type="button"
        class="ctrl-btn outline-btn my-1"
        aria-label="Left Align"
        (click)="reset()"
      >
        <img alt="" src="{{ baseHref }}/assets/images/icon-redo.svg" class="ctrl-img" />
      </button>

      <button
        *ngIf="!disabled"
        type="button"
        class="ctrl-btn main-btn red mt-2"
        aria-label="Left Align"
        (click)="moveLeft()"
      >
        <img alt="" src="{{ baseHref }}/assets/images/icon-back.png" class="ctrl-img" />
      </button>
    </div>
  </div>
  <div class="right-container">
    <div class="left-header-div">
      <span class="right-header font-gellix-bold-12-14">{{ rightHeader }}</span>
      <span class="agent-count font-gellix-medium-12-14">{{ count.assignedCount }}</span>
    </div>
    <div class="hr-divider"></div>
    <div class="input-box no-border" *ngIf="showIt">
      <div class="inp-priority">
        <input
          *ngIf="hasPersistence"
          class="chk-box"
          [(ngModel)]="persistenceModel"
          name="persistence"
          type="checkbox"
          value="Temporary"
        /><span class="checkbox-label" *ngIf="hasPersistence">Temporary</span>

        <label for="priority" class="priority" *ngIf="hasPriorities">Priority</label>

        <select
          name="groupdropdown"
          class="drpdown-input-box"
          name="priority"
          [(ngModel)]="priorityModel"
          *ngIf="hasPriorities"
        >
          <option value="select">Select</option>
          <option [ngValue]="option" *ngFor="let option of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
            {{ option }}
          </option>
        </select>

        <ng-container *ngIf="hasGroupUserRoles">
          <label for="role" class="role">Role:</label>

          <select name="roledropdown" class="drpdown-input-box role-dropdown" [(ngModel)]="roleModel">
            <option value="select">Select</option>
            <option [ngValue]="option.ID" *ngFor="let option of groupUserRoles">
              {{ option.Name }}
            </option>
          </select>
        </ng-container>
      </div>
      <div class="ctrls-input-box">
        <button *ngIf="!disabled" class="main-btn" (click)="apply()">Apply</button>
        <button *ngIf="!disabled" class="main-btn red ms-2" (click)="clear()">Clear</button>
      </div>
    </div>
    <div
      class="right-list-container"
      [ngClass]="{
        'without-inp-box': !showIt,
        'with-inp-box': showIt,
      }"
    >
      <ng-container *ngIf="assignedDisplay.length > 0 && assignedDisplay[0].options; else elseBlock">
        <select
          class="right-list-select"
          multiple="multiple"
          size="8"
          *ngIf="assignedDisplay.length > 0"
          [(ngModel)]="selectedAssignedAgents"
        >
          <ng-container *ngFor="let item of assignedDisplay">
            <optgroup [label]="item.label" *ngIf="item.isGroup != null && item.options.length > 0">
              <ng-container *ngFor="let option of item.options">
                <option
                  [value]="option.value"
                  *ngIf="option.selected == true"
                  [ngValue]="option"
                  [title]="option.tooltip"
                >
                  {{ option.label }}
                </option>
              </ng-container>
            </optgroup>
          </ng-container>
        </select>
      </ng-container>

      <ng-template #elseBlock>
        <select
          class="right-list-select"
          multiple="multiple"
          size="8"
          *ngIf="assignedDisplay.length > 0"
          [(ngModel)]="selectedAssignedAgents"
        >
          <ng-container *ngFor="let item of assignedDisplay">
            <option [value]="item.value" *ngIf="item.selected == true" [ngValue]="item" [title]="item.tooltip">
              {{ item.label }}
            </option>
          </ng-container>
        </select>
      </ng-template>
    </div>
  </div>
</div>
